export default function RadioCheckIcon() {
  return (
    <>
      <circle cx='8' cy='8' r='7.25' strokeWidth='1.5' />
      <circle cx='7.99996' cy='8' r='4' fill='#A0383F' />
    </>
  );
}
